import { useSuspenseRoleQuery } from '#api/roles.queries.ts';
import { mapRoleToForm } from '../form/mapRoleToForm.ts';
import { RoleDetailForm } from '../form/RoleDetailForm.tsx';

type Props = {
  /** The role to copy config from */
  sourceRoleId: string;
  /** Function to execute after a successful save operation. */
  onSave: () => void;
};

/**
 * {@link DuplicateRoleForm} loads the source role and renders the add-role form prefilled with its
 * description and firewall rules.  The user picks a new name; hosts are not copied.
 *
 * The source role is only needed for the initial prefill: once the form mounts, its state is
 * independent, and creating the copy succeeds even if the source is deleted before saving.  So
 * unlike editing, a background refetch 404 must not be escalated — that would destroy the user's
 * in-progress form.
 */
export function DuplicateRoleForm({ sourceRoleId, onSave }: Props) {
  const {
    data: { data: sourceRole },
  } = useSuspenseRoleQuery(sourceRoleId);

  return (
    <RoleDetailForm
      // The form only reads defaultValues on first mount, so re-mount it if the source changes
      key={sourceRole.id}
      roleId={null}
      defaultValues={{ ...mapRoleToForm(sourceRole), roleName: '' }}
      onSave={onSave}
    />
  );
}
